import { toLocaleCurrency } from 'utils/dinero'
import { INTEREST_FREE_ADVANCE_MAX_AMOUNT } from './credit'

const WORDING = {
  CARGAR_DINERO: 'CARGAR DINERO',
  TRANSFERIR_DINERO: 'TRANSFERIR DINERO',
  MOVIMIENTOS: 'Movimientos',
  VER_MAS_MOVIMIENTOS: 'Ver más movimientos',
  ALIAS_MODIFICADO:
    '¡Bárbaro! En breve te notificaremos el cambio de tu nuevo alias',
  COPIADO: 'Los datos se han copiado en portapapeles',
  CVU_TITULO:
    'Con tu CVU o alias podés recibir o transferir dinero, copiá y compartí al contacto que desees.',
  CVU: 'CVU',
  COPIAR: 'Copiar',
  CERRAR_SESION: 'Cerrar sesión',
  SEGUIR_PRESTAMO: 'Mi préstamo',
  ALIAS: 'Alias',
  ALIAS_MSG_CHARACTER_AMOUNT: 'Debe tener entre 6 y 20 caracteres',
  ALIAS_MSG_HAS_ENIE: 'Podés usar todos los números y letras excluyendo la ñ',
  ALIAS_MSG_SPECIAL_CHARACTERS:
    'Los únicos caracteres especiales válidos son “.” y “-”',
  ACTIVAR_TARJETA: 'Activar tarjeta',
  ACTIVAR_TARJETA_MSG: '¿Deseas activar tu tarjeta?',
  PAUSAR_TARJETA: 'Pausar tarjeta',
  TARJETA_BLOQUEADA: 'Su tarjeta fue bloqueada',
  TARJETA_MODAL_TITULO: 'Bloquear tarjeta',
  TARJETA_MODAL_DESCRIPCION:
    'Si seleccionas esta opción tu tarjeta pasará a estar inhabilitada de forma permanente y tendrás que solicitar una nueva tarjeta.',
  TARJETA_BLOQUEADA_TOAST: 'La tarjeta se bloqueó correctamente',
  CONFIRMAR: 'Confirmar',
  PAUSAR_TARJETA_MSG:
    '¿Deseas pausar tu tarjeta? (No podrás usarla mientras esté pausada)',
  ALIAS_SUBTITLE:
    'Modificá tu alias y creá uno a tu gusto que sea fácil de recordar.',
  INGRESA_CUENTA: 'Ingresá a tu cuenta:',
  O_INGRESA_AQUI: 'o ingresá con',
  DESCRIBI_UN_DETALLE: 'Describí un detalle de la transferencia',
  TARJETA_SOLICITADA:
    'Su tarjeta ya fue solicitada, en unos minutos se habilitará la nueva',
  MOTIVO: 'Motivo: ',
  PASSWORD_INFO: 'Nadie del equipo de Wayni va a solicitarte esta contraseña.',
  PASSWORD_SECURITY_INFO:
    'Selecioná una nueva contraseña que no hayas utilizado antes, recordá no compartirla con nadie.',
  OOPS: '¡Oops!',
  ERROR: 'Ha ocurrido un error',
  REDIRECT: 'Te redirigiremos a tu perfil para que vuelvas a intentarlo en',
  BUTTON_REDIRECT: 'También podés hacer clic en el botón 👇.',
  WAIT: '¡Esperá un toque! Nos tomará un par de segundos 😉',

  // Cards file
  MY_CARDS: 'Mis tarjetas',
  VIRTUAL: 'Virtual',
  PHYSICAL: 'Física',
  WAYNI_PLUS: 'Esta funcionalidad es exclusiva de Wayni+',
  KNOW_MORE: '¡Quiero saber más!',
  BLOCK_TEXT: 'Bloquear',
  OPTION_SELECTED: 'Selecioná una opción',
  BLOCKING_REASON: 'Motivo',
  SUSPENDED_MEMBERSHIP:
    'Para seguir disfrutando tus beneficios, aboná tus cuotas restantes.',
  SUSPENDED_MEMBERSHIP_HELP_CENTER:
    'Hacé el pago y seguí disfrutando de todos los beneficios.',
  SUSPENDED_MEMBERSHIP_PHYSICAL_CARD: (
    <>
      Aboná tus pagos pendientes para poder <br /> solicitar una tarjeta física
    </>
  ),
  SUSPENDED_MEMBERSHIP_HUB: (
    <>
      Actualiza tus pagos para poder aprovechar <br /> todos los beneficios que
      tenemos para vos.
    </>
  ),
  SUSPENDED_MEMBERSHIP_ADVANCE:
    'Hacé el pago, pedí tu adelanto y seguí disfrutando de todos los beneficios.',
  MEMBERSHIP_PRICE: 4850
}

export default WORDING

export const buttonText = {
  chargeMoney: 'Ingresar dinero',
  creditProfile: 'Mi perfil crediticio',
  advances: 'Wayni Crédito',
  installments: 'Wayni Cuotas',
  transfers: 'Enviar dinero',
  membershipFalse: (
    <span>
      Suscribite a Wayni<span className='text-green-800'>+</span>
    </span>
  ),
  membership: (
    <span>
      Mi <br /> Wayni<span className='text-green-800'>+</span>
    </span>
  )
}

export const BLOCKED_ACCOUNT_MSG =
  'Tu cuenta se encuentra bloqueada indefinidamente por varios intentos de inicio de sesión fallidos. Comunicate con el equipo de soporte.'

export const LOAN_BANNER_STEPS = [
  {
    number: 1,
    description: 'Acreditación en 24hs.'
  },
  {
    number: 2,
    description: 'Tasa fija y mejor cotización'
  },
  {
    number: 3,
    description: 'Lo pagás en hasta 12 cuotas'
  }
]

export const ADVANCE_BANNER_STEPS = [
  {
    number: 1,
    description: 'Al instante en tu billetera.'
  },
  {
    number: 2,
    description: `Hasta ${toLocaleCurrency(
      INTEREST_FREE_ADVANCE_MAX_AMOUNT
    )} a Tasa 0%`
  },
  {
    number: 3,
    description: 'Lo devolvés en 1, 2 o 3 cuotas.'
  }
]
